import { Pause } from 'iconsax-react';
import { useMemo } from 'react';
import PlayIcon from '@/assets/images/icons/play.svg?react';
import { useAudioControls } from '@/hooks/conversations/use-audio-controls';
import { useSafeMediaUrl } from '@/hooks/use-safe-media-url';
import { formatSecond } from '@/utils/second-to-time-string';
import type { ContentCommonProps } from './content-common-props';

const BAR_HEIGHT_MAX = 24;
const BAR_HEIGHT_MIN = 3;

export default function ContentAudio({ message }: ContentCommonProps) {
  const [src, ...rest] = message.Message.split('|');
  const duration = rest.at(-1) ?? '0';
  const { src: safeSrc } = useSafeMediaUrl(src);
  const { toggle, position, progress, isPlaying, isLoading } = useAudioControls(safeSrc);

  const bars = useMemo(
    () =>
      Array.from({ length: Math.min(30, Math.floor(Number.parseInt(duration) + 5)) }).map(
        () => Math.random() * (BAR_HEIGHT_MAX - BAR_HEIGHT_MIN) + BAR_HEIGHT_MIN,
      ),
    [duration],
  );

  return (
    <div
      className='chat-bubble min-w-min group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary'
      onClick={toggle}>
      <div className='flex items-center gap-2'>
        <button className='btn btn-circle btn-ghost btn-sm text-body group-data-sender:text-body'>
          {isLoading ? (
            <span className='loading loading-spinner' />
          ) : isPlaying ? (
            <Pause
              variant='Bold'
              className='size-5'
            />
          ) : (
            <PlayIcon className='size-5' />
          )}
        </button>
        <div
          className='flex items-center gap-0.5'
          style={{
            maskImage: `linear-gradient(90deg, rgba(0, 0, 0, 1), rgba(0,0,0,1) ${progress}%, rgba(0,0,0,.3) ${progress}%, rgba(0,0,0,.3))`,
          }}>
          {bars.map((height, index) => (
            <div
              key={index}
              className='w-0.5 rounded-full transition-all duration-300 ease-in-out bg-neutral-800 group-data-sender:bg-body'
              style={{ height }}
            />
          ))}
        </div>
        <div className='flex items-center gap-1 text-body2 desktop:text-body3 text-body'>
          <span>{isPlaying || position > 0 ? formatSecond(position) : formatSecond(Number(duration))}</span>
        </div>
      </div>
    </div>
  );
}
